import { updateJobsLeaseMutationGQL } from './graphql/jobUpdateLeaseApi';
import { deleteTicketApi } from './graphql/ticketDeleteApi';

import { getJobId } from './selectors';


export const types = {
  SET_JOB_ID: 'ticketViewer/SET_JOB_ID',
  SET_TICKET_ID: 'ticketViewer/SET_TICKET_ID',
};

export const setJobId = (jobId) => {
  return {
    type: types.SET_JOB_ID,
    jobId,
  };
};

export const setTicketId = (ticketId) => {
  return {
    type: types.SET_TICKET_ID,
    ticketId,
  };
};

export const dispatchUpdateJob = (jobId, leaseId) => {
  return async (_dispatch, _getState, { client }) => {
    await updateJobsLeaseMutationGQL(client, jobId, leaseId);
  };
};

export const deleteTicket = (ticketId) => {
  return async (dispatch, getState, { client }) => {
    const state = getState();
    const jobId = getJobId(state);
    await deleteTicketApi(client, ticketId, jobId);
  };
};
